<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Apple Braille", "苹方-简";
}
@import "@/common/common.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue